// extracted by mini-css-extract-plugin
export default {"root":"awoIgckaBCennz75Itbl","placeHolderShimmer":"Nvop7eGxR5Jyr5mAJ_Co"};